import React, { useState, useEffect } from 'react';
import { getMenus, createMenu } from '../services/api';

const Menus = () => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newMenuName, setNewMenuName] = useState('');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    try {
      const response = await getMenus();
      setMenus(response.data || []);
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to fetch menus' });
    } finally {
      setLoading(false);
    }
  };

  const handleAddMenu = async (e) => {
    e.preventDefault();
    if (!newMenuName.trim()) return;

    try {
      const response = await createMenu({ name: newMenuName });
      setMenus([...menus, response.data]);
      setNewMenuName('');
      setShowAddForm(false);
      setMessage({ type: 'success', text: 'Menu added successfully' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to add menu' });
    }
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  return (
    <div>
      <h1 className="page-title">Menus</h1>

      {message && (
        <div className={`message message-${message.type}`}>
          {message.type === 'success' ? '✓' : '✗'} {message.text}
        </div>
      )}

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3>All Menus</h3>
          <button 
            className="btn btn-primary"
            onClick={() => setShowAddForm(true)}
          >
            ➕ Add Menu
          </button>
        </div>

        {showAddForm && (
          <form onSubmit={handleAddMenu} style={{ marginBottom: '20px', padding: '20px', backgroundColor: '#2a2a2a', borderRadius: '8px' }}>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'end' }}>
              <div style={{ flex: 1 }}>
                <label className="form-label">Menu Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={newMenuName}
                  onChange={(e) => setNewMenuName(e.target.value)}
                  placeholder="Enter menu name"
                  required
                />
              </div>
              <div>
                <button type="submit" className="btn btn-success">
                  ✓ Add
                </button>
              </div>
              <div>
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={() => setShowAddForm(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        )}

        {menus.length === 0 ? (
          <div className="empty-state">
            <h3>No menus found</h3>
            <p>Start by adding your first menu</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '15px' }}>
            {menus.map((menu) => (
              <div 
                key={menu._id} 
                style={{ 
                  padding: '20px', 
                  backgroundColor: '#2a2a2a', 
                  borderRadius: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <h4 className="menu-name-label" style={{ margin: '0' }}>📋 {menu.name}</h4>
                  <p style={{ margin: '5px 0 0 0', color: '#b0b0b0', fontSize: '14px' }}>
                    Menu ID: {menu._id}
                  </p>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button className="btn btn-secondary" style={{ padding: '8px 16px', fontSize: '12px' }}>
                    View Categories
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Menus;
